// frontend/src/components/dashboard/ContinueLearningCard.tsx

import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ActiveCourseSummary } from '../../types/dashboard.types';

interface ContinueLearningCardProps {
  course: ActiveCourseSummary | null;
}

export function ContinueLearningCard({ course }: ContinueLearningCardProps) {
  if (!course) return null;

  return (
    <div className="nd-continue-card">
      <h2 className="nd-section-title">
        <span style={{ marginRight: '8px' }}>🎯</span>
        Kaldığın Yerden Devam Et
      </h2>
      <div className="nd-continue-inner">
        <div className="nd-continue-icon-wrap">
          <span className="nd-continue-icon">{course.icon}</span>
        </div>
        <div className="nd-continue-info">
          <h3 className="nd-continue-title">{course.title}</h3>
          <p className="nd-continue-subtitle">Öğrenme yolculuğuna kaldığın noktadan hız kesmeden devam et</p>
          <div className="nd-continue-progress-row">
            <div className="nd-continue-bar-wrap">
              <div className="nd-continue-bar" style={{ width: `${course.progressPercent}%` }} />
            </div>
            <span className="nd-continue-pct">%{course.progressPercent}</span>
          </div>
        </div>
        <Link to={`/courses/${course.id}`} className="nd-continue-btn">
          Derse Başla <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}

